var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_83)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9863 -0.00927734C7.15199 -0.00927734 -0.00933838 7.15206 -0.00933838 15.9864C-0.00933838 24.8204 7.15199 31.9817 15.9863 31.9817C24.8203 31.9817 31.9817 24.8204 31.9817 15.9864C31.9817 7.15206 24.8203 -0.00927734 15.9863 -0.00927734ZM15.986 6.29806C18.655 6.29806 20.8193 8.46206 20.8193 11.1314C20.8193 13.8007 18.6553 15.9651 15.986 15.9651C13.3163 15.9651 11.1523 13.8011 11.1523 11.1314C11.1523 8.46206 13.3163 6.29806 15.986 6.29806ZM16.0317 24.6237H8.93333C8.93333 19.8604 11.525 18.1644 13.2247 16.6424C14.0483 17.0851 14.9877 17.3391 15.986 17.3464C16.9837 17.3391 17.923 17.0851 18.7463 16.6424C20.4467 18.1647 23.0383 19.8604 23.0383 24.6237H16.0317Z",
    fill: "#B17457"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_83",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 2,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.812 30.9813H31.1753V31.2957H30.812V30.9813Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_83)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_83",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 2,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1743 31.0913C31.0143 31.3537 30.8607 31.3023 30.8287 31.2513C30.7967 31.1937 30.8223 31.04 30.8737 31.0017C30.9247 30.9567 31.1297 31.0143 31.1297 31.0143",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5727 30.7457H31.4373V31.5841H30.5727V30.7457Z",
    fill: "#E7191F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalized);
export default __webpack_public_path__ + "static/media/personalized.4f921e7917027b3ad1c343ff03a7064a.svg";
export { ForwardRef as ReactComponent };